import { Link, useNavigate } from "react-router-dom";
import Logo from "../../assets/Logo.png";
import "./pesquisar.css";
import { useState } from "react";
import validator, {cnpj, cpf} from "cpf-cnpj-validator";
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

function Pesquisar() {

    const [cgccliente, setCgccliente ] = useState ("");
    const [vMensagem, setMengasem] = useState("");
    const navigate = useNavigate();        


    function ConsultarBoleto(){        
        
        if ((cpf.isValid(cgccliente)) || (cnpj.isValid(cgccliente))) {
            //consultar boletos            
            navigate("/boletos/"+ cgccliente.replaceAll('.','').replaceAll('-','').replaceAll('/','') )            
        } else {            
            toast.error("CPF ou CPNF Invalido")
        }
    
    }
        
    return <>

               
        <div className="container-fluid h-100 dados">     
                                  

            <div className="position-absolute top-50 start-50 translate-middle ">
                

                <div className="mb-4 d-flex justify-content-center">
                    <img src={Logo} className="img-logo" alt={Logo} />                                              
                </div>       

                <label htmlFor="InputNome" className="form-label d-flex justify-content-center text-center mb-3">Para consultar seus boletos informe CPF ou CNPJ</label>
                
                <div className="input-group mb-3">
                    <input onChange={(e) => setCgccliente(e.target.value)} type="text" className="form-control text-center" aria-label="Sizing example input" aria-describedby="inputGroup-sizing-default" />
                </div>

                <div className="d-grid gap-2">
                     <button className="btn btn-primary" type="button" onClick={ConsultarBoleto}>Consultar</button>
                </div>                                
                
            </div> 

            
            
            <ToastContainer />          
        </div>

        
      
    </>


    


}

export default Pesquisar;